import React from 'react';

class Jumbotron extends React.Component {
  render() {
    return (
        /*<div className="row client-access-title">
            <div className="page-title-area col-sm-12">
                <h1 className="page-title">Welcome to Sponsor Central</h1>
                <div className="border-under-title"></div>
            </div>
        </div> */ 	
		<div />
    );
  }
}

export default Jumbotron;